// AWS TODO: Create Lambda at FETCH_GAME_HISTORY endpoint
// Input: GET ?userId=xxx
// Output: { visionHistory: [{date (ISO string), score, accuracy, speed}], colorGuesserHistory: [{date, score}] }
// Data source: DynamoDB game history table (games are already written by analyzeGame + processColorGuesser lambdas)

import { FETCH_GAME_HISTORY } from "../Endpoints";

export const fetchGameHistory = async (userId) => {
    console.log("[API Request] - fetchGameHistory");
    try {
        const response = await fetch(`${FETCH_GAME_HISTORY}?userId=${encodeURIComponent(userId)}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error("Network response was not ok.");
        }

        const data = await response.json();
        const body = data['body'] || data;
        return {
            visionHistory: body.visionHistory || [],
            colorGuesserHistory: body.colorGuesserHistory || [],
        };
    } catch (error) {
        console.log("Error fetching game history (returning mock data for dev):", error);
        // Mock fallback
        return {
            visionHistory: [
                { date: '2024-03-01', score: 12, accuracy: 75 },
                { date: '2024-03-03', score: 15, accuracy: 80 },
                { date: '2024-03-05', score: 18, accuracy: 88 },
                { date: '2024-03-07', score: 14, accuracy: 72 },
                { date: '2024-03-10', score: 22, accuracy: 91 },
            ],
            colorGuesserHistory: [
                { date: '2024-03-02', score: 8 },
                { date: '2024-03-04', score: 11 },
                { date: '2024-03-06', score: 15 },
                { date: '2024-03-09', score: 13 },
            ],
        };
    }
};
